<div class="faq-panel" [class.open]="isOpen">
    <div class="faq-panel-header">
      <h2>Frequently Asked Questions</h2>
      <button class="close-btn" (click)="close($event)">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div class="faq-panel-content">
      <ng-container *ngIf="isLoadingFaq">
        <div class="faq-skeleton" *ngFor="let i of [1,2,3,4]">
          <div class="skeleton-question"></div>
          <div class="skeleton-answer"></div>
        </div>
      </ng-container>
      <ng-container *ngIf="!isLoadingFaq">
        <div class="faq-item" *ngFor="let faq of faqList">
          <h3 class="faq-question" (click)="faq.isOpen = !faq.isOpen" (keydown)="faq.isOpen = !faq.isOpen">
            <span [innerHTML]="faq.question"></span>
            <mat-icon class="arrow-icon">{{ faq.isOpen ? 'expand_less' : 'expand_more' }}</mat-icon>
          </h3>
          <div class="faq-answer" [class.open]="faq.isOpen">
            <span [innerHTML]="faq.answer"></span>
          </div>
        </div>
      </ng-container>
    </div>
  </div>

  <div class="faq-overlay" [class.open]="isOpen" (click)="close($event)" (keydown)="close($event)"></div>